module.exports = __webpack_public_path__ + "static/media/autorizaciones.76edfdce.svg";